import { render, staticRenderFns } from "./EditarClasificacionVentas.vue?vue&type=template&id=80ec4ea8"
import script from "./EditarClasificacionVentas.vue?vue&type=script&lang=js"
export * from "./EditarClasificacionVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports